import RefappZoom from './directives/RefappZoom';
import './styles/style.scss';

export default {
  install(app) {
    app.directive('refapp-zoom', RefappZoom);
  },
};
